export default function FacebookIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6221_21133)">
        <path
          d="M2.93001 16V8.49234H0.944824V5.78922H2.93001V3.4804C2.93001 1.66611 4.10266 0 6.80471 0C7.89873 0 8.7077 0.10488 8.7077 0.10488L8.64396 2.62914C8.64396 2.62914 7.81894 2.6211 6.91863 2.6211C5.94423 2.6211 5.78812 3.07014 5.78812 3.81544V5.78922H8.72142L8.59378 8.49234H5.78812V16H2.93001Z"
          fill="#0A1B2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_6221_21133">
          <rect width="7.77728" height="16" fill="white" transform="translate(0.944336)" />
        </clipPath>
      </defs>
    </svg>
  );
}
